import { qs, qsa, on } from '../../core/dom';
import type { NavModuleInit } from '../../core/types';

const SEARCH_URL = '/ai-search/';

declare global {
  interface Window {
    initSearch?: (cfg: Record<string, unknown>) => void;
    country?: string;
  }
}

const init: NavModuleInit = ({ state, bus }) => {
  const entries = qsa<HTMLElement>('.search-entry-point-home, [data-gn-trigger="search"]');
  const mobileButtons = qsa<HTMLElement>('.categorySearchButton, [data-gn-trigger="search-open"]');
  if (entries.length === 0 && mobileButtons.length === 0) return;

  const suggestions = (state.searchSuggestions ?? []).filter(
    (s) => typeof s === 'string' && s.trim().length > 0,
  );
  const placeholderList = [...suggestions.slice(0, 5), 'Curious?'];

  entries.forEach((entry) => {
    const list = qs<HTMLElement>('.placeholder-list', entry);
    if (!list) return;
    const childTag = list.tagName === 'UL' ? 'li' : 'span';
    list.innerHTML = '';
    placeholderList.forEach((text) => {
      const item = document.createElement(childTag);
      item.className = 'placeholder-text';
      item.textContent = text;
      list.appendChild(item);
    });
    const firstClone = document.createElement(childTag);
    firstClone.className = 'placeholder-text';
    firstClone.setAttribute('aria-hidden', 'true');
    firstClone.textContent = placeholderList[0] ?? '';
    list.appendChild(firstClone);

    list.classList.add(`slideY-${placeholderList.length}`);
  });

  const region = (state.country ?? 'au').toLowerCase();
  const isAuNonShopping =
    region === 'au' &&
    !location.href.includes('au-shopping') &&
    !location.href.includes('findershopping');

  const handleSearchClick = (isMobile: boolean) => {
    bus.emit('search:focus');
    const config: Record<string, unknown> = {
      isAuNonShopping,
      aiSearchModalIsOpen: true,
      region,
      suggestions,
    };
    if (isMobile) config.aiSearchInputSize = 'xsmall';
    else config.className = 'search-entry-point-home';

    if (typeof window.initSearch === 'function') {
      try {
        window.initSearch(config);
        return;
      } catch {}
    }
    location.href = SEARCH_URL;
  };

  const offs: Array<() => void> = [];

  entries.forEach((entry) => {
    offs.push(on(entry, 'click', () => handleSearchClick(false)));
    offs.push(
      on(entry, 'keydown', ((e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleSearchClick(false);
        }
      }) as (e: Event) => void),
    );
  });

  mobileButtons.forEach((btn) => {
    offs.push(on(btn, 'click', () => handleSearchClick(true)));
  });

  return {
    destroy: () => {
      offs.forEach((off) => off());
    },
  };
};

export default init;
